import { useAsyncCallback } from 'react-async-hook';
import { useInviteStore } from '../store/use-invite-store';
import { useUploadBusyStore } from '../store/use-upload-busy-store';
import { api } from './instance';
import { decorateError } from './utils';

export function useAttachmentUpload() {
  const { invite, addAttachment } = useInviteStore();

  const start = useUploadBusyStore((s) => s.start);
  const stop = useUploadBusyStore((s) => s.stop);

  return useAsyncCallback(async (file) => {
    if (file) {
      start();
      try {
        const formData = new FormData();
        formData.append('file', file);
        formData.append('shortDescription', file.name);
        formData.append('relatedEntityId', invite.id);
        formData.append('type', 'Other');
        formData.append('isConfidential', true);

        const data = await api.auth.post('attachment/upload', { body: formData }).json();
        if (data?.attachmentId) {
          addAttachment({
            attachmentId: data.attachmentId,
            fileName: data.originalFileName ?? file.name,
            contentType: data.contentType,
            shortDescription: '',
          });
          return data.attachmentId;
        }
      } catch (error) {
        throw decorateError(error, 'errors.uploadFailed.title', 'errors.uploadFailed.details');
      } finally {
        stop();
      }
    }

    return null;
  });
}
